var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", { staticClass: "tr-td-control tr-edit-text" }, [
    _vm.r_disp_title
      ? _c("td", { staticClass: "td-dataname" }, [
          _c("div", [
            _vm._v(_vm._s(_vm.r_title) + "\r\n\t\t\t"),
            _vm._v(" "),
            _vm.r_settings.edit_right &&
            (_vm.r_is_require || _vm.r_is_display_require_text) &&
            !_vm.r_is_not_display_require_text
              ? _c(
                  "div",
                  { staticClass: "layout-right" },
                  [_c("font", { staticClass: "text-red" }, [_vm._v("＊")])],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.m_isEdit
              ? _c(
                  "div",
                  { staticClass: "layout-right" },
                  [_c("font", { staticClass: "text-red" }, [_vm._v("*")])],
                  1
                )
              : _vm._e()
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.r_settings.edit_right
      ? _c(
          "td",
          { class: _vm.td_data_class },
          [
            _c(
              "el-form",
              {
                ref: "valid_target",
                staticClass: "text_code_area",
                attrs: { model: _vm.m_ruleForm, rules: _vm.m_validationText }
              },
              [
                _c("div", { staticClass: "text_code" }, [
                  _vm._v(
                    "\r\n\t\t\t\t" + _vm._s(_vm.r_text_header) + "\r\n\t\t\t"
                  )
                ]),
                _c(
                  "el-form-item",
                  {
                    staticClass: "text_code disp-text",
                    attrs: { prop: "text" }
                  },
                  [
                    _c("c-inputedit", {
                      attrs: {
                        r_disabled: _vm.r_disabled,
                        r_type: _vm.r_validattype,
                        r_max_length: _vm.max_length,
                        r_max_fra_length: _vm.max_fra_length,
                        r_input_class: _vm.createEditClassType(
                          _vm.m_ruleForm.text
                        ),
                        r_placeholder: _vm.r_placeholder,
                        r_data_change_check_str: _vm.r_data_change_check_str,
                        r_text_footer: _vm.r_text_footer
                      },
                      on: {
                        input: _vm.onInputName,
                        blur: _vm.onBlur,
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.onKeyup($event)
                        }
                      },
                      model: {
                        value: _vm.m_ruleForm.text,
                        callback: function($$v) {
                          _vm.$set(_vm.m_ruleForm, "text", $$v)
                        },
                        expression: "m_ruleForm.text"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm._t("footer_slot")
          ],
          2
        )
      : _c("td", { staticClass: "td-data" }, [
          _c("div", { staticClass: "text_code" }, [
            _vm._v("\r\n\t\t\t" + _vm._s(_vm.r_text_header) + "\r\n\t\t")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.r_class },
            [
              _c("font", { class: { "text-red": _vm.m_isEdit } }, [
                _vm._v(
                  "\r\n\t\t\t\t" +
                    _vm._s(
                      _vm._f("addComma")(_vm.m_ruleForm.text, _vm.r_add_comma)
                    ) +
                    "\r\n\t\t\t"
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.r_text_footer !== ""
            ? _c("div", { staticClass: "footer-text" }, [
                _vm._v("\r\n\t\t\t" + _vm._s(_vm.r_text_footer) + "\r\n\t\t")
              ])
            : _vm._e()
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-910bd0ce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-910bd0ce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/parts_com/TR/editText.vue
// module id = 618
// module chunks = 0 1 2